<template>
<div class="licenses-page">

    <div class="callout callout-success" v-if="$route.params.license">
        <h1>Payment Success</h1>
        <p>Thank you for purchasing {{selectedLicense.type}} and supporting us!</p>
        <p>Your activation code is: </p>
        <p><b>{{selectedLicense.activation_code}}</b></p>

    </div>

    <div class="licenses">

        <p>Licenses are used to activate SOS List and connect your account to your software.</p>

        <div v-if="licenses.length>0">
        	<License :license="license" v-for="license in licenses" :key="license.download_uuid" :isMac="isMac" :isWindows="isWindows" :fingerprint="fingerprint" />
        </div>
        <div v-else class="no-licenses-message">
            <h3>
                You currently have no SOS licenses
            </h3>
            <button @click="$router.push({name:'pricing'})">
                Purchase License
            </button>
        </div>
    </div>

</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import store from "@/store"
import License from "@/components/license/License";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import Platform from "platform";
export default {
    name: "LicensesMenu",

    components: {
        License,
    },

    beforeRouteEnter(to, from, next) {
        store.dispatch("loadLicenses").then(function () {
            next();
		}).catch(() => {
			next();
		});

    },

    data() {
        return {
            fingerprint: "",
            isMac: false,
            isWindows: false,
        }
    },

    created() {
        var temp = this;
        // Initialize an agent at application startup.
        FingerprintJS.load().then(function (fp) {
            fp.get().then(function (result) {
                var visitorId = result.visitorId
                temp.fingerprint = visitorId
            })
        }).catch(function (error) {})

        this.isMac = Platform.os.family.includes("OS X");
        this.isWindows = Platform.os.family.includes("Windows");

    },

    methods: {
        getDownload() {
            var routeData = this.$router.resolve({
                name: 'download'
            });
            window.open(routeData.href, '_blank');
        },
        purchaseSOS() {
            window.open("/sos/buy", '_blank');
        }
    },
    computed: {
        selectedLicense() {

            var result = null;

            if (this.$route.params.license) {
                for (var i = 0; i < this.licenses.length; i++) {
                    if (this.$route.params.license == this.licenses[i].license_uuid) {
                        result = this.licenses[i];
                        break;
                    }
                }
            }

            return result;

        },
        ...mapGetters(["licenses"])
    }
}
</script>
